/* eslint-disable react/jsx-no-target-blank */
import React, { useContext, useEffect, useState } from 'react'
// import {useIntl} from 'react-intl'
import { checkIsActive, KTSVG } from '../../../helpers'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
// import { IsAuthorizedContext } from '../../../../app/contexts/isAuthorizedContext';
import { useAuth } from '../../../../app/contexts/CustomContextHook/useAuth'
import { useHistory, useLocation } from 'react-router-dom'
import { useLayout } from '../../core'
import clsx from 'clsx'

export function AsideMenuMain() {
  // const intl = useIntl()

  // const isAuthorizedCxt = useContext(IsAuthorizedContext);

  const { UserToken, setUserToken } = useAuth()

  const history = useHistory()

  console.log(JSON.parse(atob(UserToken.token.split('.')[1])))

  let isUsersClaim = !!JSON.parse(atob(UserToken.token.split('.')[1])).UsersClaim
  let isStatesClaim = !!JSON.parse(atob(UserToken.token.split('.')[1])).StatesClaim
  let isRuleSetsClaim = !!JSON.parse(atob(UserToken.token.split('.')[1])).RuleSetsClaim

  console.log('isUsersClaim : ', isUsersClaim)
  console.log('isStatesClaim : ', isStatesClaim)

  // const [isAdmin, setIsAdmin] = useState(false)

  let isAdmin = false
  let isManager = false

  if (UserToken.Roles.length > 0) {
    UserToken.Roles.forEach((role) => {
      var role = role.replace('["', '').replace('"]', '').toLocaleLowerCase()

      if (role == 'admin') {
        isAdmin = true
      } // if (role.toLowerCase().includes('admin')) {
      //   isAdmin = true;
      // } else if (role.toLowerCase().includes('manager')) {
      //   isManager = true;

      // }
    })
  }

  const logout = () => {
    console.log('-------------logout---------------')

    setUserToken('', '', '', '', [], '', '', '', '')
  }

  return (
    <>
      <>
        <AsideMenuItem
          to='/dashboard'
          icon='/media/icons/duotune/art/art002.svg'
          title={'Dashboard'}
          fontIcon='bi-app-indicator'
        />
        <AsideMenuItem
          to='/bookings'
          icon='/media/icons/duotune/finance/fin001.svg'
          title={'Bookings'}
          fontIcon='bi-app-indicator'
        />
        <AsideMenuItem
          to='/halls'
          icon='/media/icons/duotune/finance/fin001.svg'
          title={'Halls'}
          fontIcon='bi-app-indicator'
        />
        <AsideMenuItem
          to='/menuItems'
          icon='/media/icons/duotune/finance/fin001.svg'
          title={'Menu Items'}
          fontIcon='bi-app-indicator'
        />
        <AsideMenuItem
          to='/menuPackages'
          icon='/media/icons/duotune/finance/fin001.svg'
          title={'Menu Packages'}
          fontIcon='bi-app-indicator'
        />

        <AsideMenuItem
          to='/services'
          icon='/media/icons/duotune/finance/fin001.svg'
          title={'Club Service'}
          fontIcon='bi-app-indicator'
        />

        <AsideMenuItem
          to='/invoice'
          icon='/media/icons/duotune/communication/com006.svg'
          title={'Invoices'}
          fontIcon='bi-app-indicator'
        />

        <AsideMenuItem
          to='/appSettings'
          icon='/media/icons/duotune/communication/com006.svg'
          title={'App Settings'}
          fontIcon='bi-app-indicator'
        />


        <>
          <AsideMenuItem
            to='/roles'
            icon='/media/icons/duotune/general/gen051.svg'
            title={'Roles'}
            fontIcon='bi-app-indicator'
          />

          <AsideMenuItem
            to='/users'
            icon='/media/icons/duotune/communication/com006.svg'
            title={'Users'}
            fontIcon='bi-app-indicator'
          />
        </>

        {/* {(isUsersClaim || isAdmin) &&
          <>
            <AsideMenuItem
              to='/roles'
              icon='/media/icons/duotune/general/gen051.svg'
              title={'Roles'}
              fontIcon='bi-app-indicator'
            />


            <AsideMenuItem
              to='/users'
              icon='/media/icons/duotune/communication/com006.svg'
              title={'Users'}
              fontIcon='bi-app-indicator'
            />
          </>}
 */}
        <div className='menu-item'>
          <a target='_blank' className='menu-link' onClick={logout}>
            <span className='menu-icon'>
              <i className='bi bi-arrow-up-left-circle-fill m-3 svg-icon-2'></i>

              {/* <KTSVG path='/media/icons/duotune/general/gen005.svg' className='' /> */}
            </span>
            <span className='menu-title'>Sign Out</span>
          </a>
        </div>
      </>
    </>
  )
}
